import type { Lender, LenderId, Outcome } from "../types";
import { Icon } from "./Icon";

interface Props {
  lenders: Lender[];
  active: LenderId;
  onChange: (id: LenderId) => void;
  outcomes: Outcome[];
}

export function LenderTabs({ lenders, active, onChange, outcomes }: Props) {
  return (
    <div className="tabs" role="tablist">
      {lenders.map((l) => {
        const lOut = outcomes.filter((o) => o.lender === l.id);
        const ok = lOut.find((o) => o.status === "approved");
        const declined = lOut.length > 0 && !ok;
        return (
          <button
            key={l.id}
            type="button"
            className={`tab ${active === l.id ? "is-active" : ""}`}
            onClick={() => onChange(l.id)}
            role="tab"
            aria-selected={active === l.id}
          >
            <span className="tab__swatch" style={{ background: l.swatch }} />
            <span className="tab__name">{l.name}</span>
            {ok && (
              <span className="tab__badge tab__badge--ok">
                <Icon.Check width={9} height={9} />
              </span>
            )}
            {declined && !ok && <span className="tab__badge tab__badge--decline" />}
          </button>
        );
      })}
    </div>
  );
}
